module.exports = __webpack_public_path__ + "img/ic_check.ec3d85d1.svg";